import React, { useState, useEffect } from 'react';
import Axios from 'axios';

const Section1 = () => {
  const [governance, setGovernance] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  useEffect(() => {
    // Make the Axios GET request to fetch data
    Axios.get('https://api.mbasolutions.co/api/categories/get')
      .then((response) => {
        // Filter the data to find the object with name: "Auditing"
        const Govereness = response.data.find(item => item.name === "Governance, Risk and Compliance");

        // Set the auditing data in the state
        setGovernance(Govereness);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, []);

  return (
    <div className='my-8 mt-16 sectionlayout '>
      {governance ? (
        <div>
          
          <h1 className='text-[32px] font-bold drop-shadow-lg text-center'> {governance.name}</h1>
          {/* Add more data properties here */}

  <div className={`flex justify-center item-center  ${governance.image?'my-20':'mb-20'
  }` }>
            {!imageLoaded && <div className='justify-center items-center flex h-[70vh]'><span className='loader'></span></div>}

          <img src={`https://api.mbasolutions.co${governance.image}`} onLoad={handleImageLoad} className="max-w-full rounded-md mx-auto max-h-[70vh]" alt='Governess' />
          </div>
          <p className='mb-12 text-center'>{governance.paragraph}</p>


        </div>
        
      ) : (
         <div className='justify-center items-center flex h-[70vh]'><span className='loader'></span></div>
      )}

     
    </div>
  );
}

export default Section1;
